/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAttestationV3Resp
 */
export interface PostAttestationV3Resp {
    /**
     * 
     * @type {string}
     * @memberof PostAttestationV3Resp
     */
    token?: string;
}

/**
 * Check if a given object implements the PostAttestationV3Resp interface.
 */
export function instanceOfPostAttestationV3Resp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostAttestationV3RespFromJSON(json: any): PostAttestationV3Resp {
    return PostAttestationV3RespFromJSONTyped(json, false);
}

export function PostAttestationV3RespFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAttestationV3Resp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function PostAttestationV3RespToJSON(value?: PostAttestationV3Resp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

